// extracted by mini-css-extract-plugin
export default {"input":"Input_input__I8dK2","input__wrapper":"Input_input__wrapper__3hqSw","input__button":"Input_input__button__4uGI1"};